<template>
    <div class="management">
        <div class="row">
            <div
                class="col-12 col-md-6 col-lg-3"
                v-if="$authUser.hasRoleOrAdmin('skill')">
                <b-card
                    class="skills-card apprentice-simple-card-with-banner card-icon-styling"
                    no-body
                    @click="redirectSkills">
                    <b-button
                        class="btn-user-chart remove-icon-margin fa-4x"
                        variant="primary-icon-only"></b-button>
                    <b-card-body body-class="skills-card-body body">
                        <b-card-title title-tag="h5">{{ $t('management.skills') }}</b-card-title>
                        <div class="muted-text">
                            {{
                                $t(
                                    'management.prepare_sets_of_skills_here_where_students_can_gain_insight_into_their_development_based_on_skills',
                                )
                            }}
                        </div>
                    </b-card-body>
                </b-card>
            </div>
            <div
                class="col-12 col-md-6 col-lg-3"
                v-if="$authUser.hasRoleOrAdmin('profile')">
                <b-card
                    class="profile-card apprentice-simple-card-with-banner card-icon-styling"
                    no-body
                    @click="redirectProfile">
                    <b-button
                        class="btn-users remove-icon-margin fa-4x"
                        variant="primary-icon-only"></b-button>
                    <b-card-body body-class="profile-card-body body">
                        <b-card-title title-tag="h5">{{ $t('management.students') }}</b-card-title>
                        <div class="muted-text">
                            {{ $t('management.adjust_settings_here_that_relate_to_students_profile_page') }}
                        </div>
                    </b-card-body>
                </b-card>
            </div>

            <div
                class="col-12 col-md-6 col-lg-3"
                v-if="$authUser.isAdmin()">
                <b-card
                    class="school-attachments-card apprentice-simple-card-with-banner card-icon-styling"
                    no-body
                    @click="redirectAccounts">
                    <b-button
                        class="btn-users-cog remove-icon-margin fa-4x"
                        variant="primary-icon-only"></b-button>
                    <b-card-body body-class="school-attachments-card-body body">
                        <b-card-title title-tag="h5">Accounts</b-card-title>
                        <div class="muted-text">
                            {{ $t('management.manage_the_accounts_for_students_and_teachers_here') }}
                        </div>
                    </b-card-body>
                </b-card>
            </div>

            <div
                class="col-12 col-md-6 col-lg-3"
                v-if="($authUser.isAdmin() || userPermissionsIn['modules']) && hasModulesIn">
                <b-card
                    class="module-card apprentice-simple-card-with-banner card-icon-styling"
                    no-body
                    @click="redirectModule">
                    <b-button
                        class="btn-check-list remove-icon-margin fa-4x"
                        variant="primary-icon-only"></b-button>
                    <b-card-body body-class="module-card-body body">
                        <b-card-title title-tag="h5">Modules</b-card-title>
                        <div class="muted-text">
                            {{
                                $t(
                                    'management.prepare_modules_here_for_the_students_to_choose_from_modules_can_be_courses_sub_courses_or_individual_activities',
                                )
                            }}
                        </div>
                    </b-card-body>
                </b-card>
            </div>

            <div
                class="col-12 col-md-6 col-lg-3"
                v-if="hasInternshipsIn">
                <!--$authUser.hasRoleOrAdmin('internship') &&-->
                <b-card
                    class="module-card apprentice-simple-card-with-banner card-icon-styling"
                    no-body
                    @click="redirectInternship">
                    <b-button
                        class="btn-table-head remove-icon-margin fa-4x"
                        variant="primary-icon-only">
                    </b-button>
                    <b-card-body body-class="module-card-body body">
                        <b-card-title title-tag="h5">{{ $t('management.internship_bank') }}</b-card-title>
                        <div class="muted-text">
                            {{ $t('management.manage_all_internships_that_students_can_choose_from_here') }}
                        </div>
                    </b-card-body>
                </b-card>
            </div>

            <div
                class="col-12 col-md-6 col-lg-3"
                v-if="hasLearningPathIn">
                <b-card
                    class="module-card apprentice-simple-card-with-banner card-icon-styling"
                    no-body
                    @click="redirectLearningPath">
                    <b-button
                        class="btn-book-reading remove-icon-margin fa-4x"
                        variant="primary-icon-only">
                    </b-button>
                    <b-card-body body-class="module-card-body body">
                        <b-card-title title-tag="h5">{{ $t('management.new_learning_path') }}</b-card-title>
                        <div class="muted-text">
                            {{ $t('management.manage_the_new_learning_path_here') }}
                        </div>
                    </b-card-body>
                </b-card>
            </div>
            <div
                class="col-12 col-md-6 col-lg-3"
                v-if="hasSluDashboardIn">
                <b-card
                    class="module-card apprentice-simple-card-with-banner card-icon-styling"
                    no-body
                    @click="redirectSluDashboard">
                    <b-button
                        class="btn-backpack remove-icon-margin fa-4x"
                        variant="primary-icon-only">
                    </b-button>
                    <b-card-body body-class="module-card-body body">
                        <b-card-title title-tag="h5"
                            ><span v-if="sluSchoolSettingsIn.module_name"> {{ sluSchoolSettingsIn.module_name }} </span>
                            <span v-else>Slu Dashboard</span></b-card-title
                        >
                        <div class="muted-text">
                            {{ $t('management.view_here_the') }}
                            <span v-if="sluSchoolSettingsIn.module_name">{{ sluSchoolSettingsIn.module_name }}</span
                            ><span v-else>Slu Dashboard</span>.
                        </div>
                    </b-card-body>
                </b-card>
            </div>

            <div
                class="col-12 col-md-6 col-lg-3"
                v-if="hasProfileChoiceIn">
                <b-card
                    class="module-card apprentice-simple-card-with-banner card-icon-styling"
                    no-body
                    @click="redirectProfileChoice">
                    <b-button
                        class="btn-clipboard remove-icon-margin fa-4x"
                        variant="primary-icon-only"></b-button>
                    <b-card-body body-class="module-card-body body">
                        <b-card-title title-tag="h5">{{ $t('management.profile_choice') }}</b-card-title>
                        <div class="muted-text">
                            {{ $t('management.prepare_profile_options_here_for_students_to_choose_from') }}
                        </div>
                    </b-card-body>
                </b-card>
            </div>

            <!--            <div class="col-12 col-md-6 col-lg-3">-->
            <!--                <b-card no-body class="module-card apprentice-simple-card-with-banner card-icon-styling"  @click="redirectPeriods">-->
            <!--                    <b-button-->
            <!--                        variant="primary-icon-only"-->
            <!--                        class="btn-calendar remove-icon-margin fa-4x"-->
            <!--                    ></b-button>-->
            <!--                    <b-card-body body-class="module-card-body body">-->
            <!--                        <b-card-title title-tag="h5">Periodes</b-card-title>-->
            <!--                        <div class="muted-text">-->
            <!--                            Zet hier periodes klaar waar voor onder andere modules.-->
            <!--                        </div>-->
            <!--                    </b-card-body>-->
            <!--                </b-card>-->
            <!--            </div>-->

            <div
                class="col-12 col-md-6 col-lg-3"
                v-if="$authUser.hasRoleOrAdmin('form') && hasCustomFormsIn">
                <b-card
                    class="module-card apprentice-simple-card-with-banner card-icon-styling"
                    no-body
                    @click="redirectCustomForms">
                    <b-button
                        class="btn-check-list remove-icon-margin fa-4x"
                        variant="primary-icon-only"></b-button>
                    <b-card-body body-class="module-card-body body">
                        <b-card-title title-tag="h5">{{ $t('management.questionnaires') }}</b-card-title>
                        <div class="muted-text">
                            {{ $t('management.view_questionnaires_here') }}
                        </div>
                    </b-card-body>
                </b-card>
            </div>

            <div
                class="col-12 col-md-6 col-lg-3"
                v-if="$authUser.isAdmin()">
                <b-card
                    class="statistics-card apprentice-simple-card-with-banner card-icon-styling"
                    no-body
                    @click="redirectStatistics">
                    <b-button
                        class="btn-chart-line remove-icon-margin fa-4x"
                        variant="primary-icon-only"></b-button>
                    <b-card-body body-class="statistics-card-body body">
                        <b-card-title title-tag="h5">{{ $t('management.statistics') }}</b-card-title>
                        <div class="muted-text">
                            {{ $t('management.view_statistics_here') }}
                        </div>
                    </b-card-body>
                </b-card>
            </div>

            <div
                class="col-12 col-md-6 col-lg-3"
                v-if="$authUser.isAdmin()">
                <b-card
                    class="las-card apprentice-simple-card-with-banner card-icon-styling"
                    no-body
                    @click="redirectLas">
                    <b-button
                        class="btn-link-before remove-icon-margin fa-4x"
                        variant="primary-icon-only"></b-button>
                    <b-card-body body-class="las-card-body body">
                        <b-card-title title-tag="h5">Las</b-card-title>
                        <div class="muted-text">
                            {{ $t('management.view_las_connections_here') }}
                        </div>
                    </b-card-body>
                </b-card>
            </div>

            <div
                class="col-12 col-md-6 col-lg-3"
                v-if="$authUser.isAdmin()">
                <b-card
                    class="digistudies-card apprentice-simple-card-with-banner card-icon-styling"
                    no-body
                    @click="redirectDigistudies">
                    <b-button
                        class="btn-studies remove-icon-margin fa-4x"
                        variant="primary-icon-only"></b-button>
                    <b-card-body body-class="digistudies-card-body body">
                        <b-card-title title-tag="h5">Digistudies</b-card-title>
                        <div class="muted-text">
                            {{ $t('management.digistudies_access') }}
                        </div>
                    </b-card-body>
                </b-card>
            </div>

            <div
                class="col-12 col-md-6 col-lg-3"
                v-if="$authUser.isAdmin()">
                <b-card
                    class="school-data-card apprentice-simple-card-with-banner card-icon-styling"
                    no-body
                    @click="redirectSchoolData">
                    <b-button
                        class="btn-address remove-icon-margin fa-4x"
                        variant="primary-icon-only"></b-button>
                    <b-card-body body-class="school-data-card-body body">
                        <b-card-title title-tag="h5">{{ $t('management.address_details') }}</b-card-title>
                        <div class="muted-text">
                            {{ $t('management.edit_the_address_details_of_the_school_here') }}
                        </div>
                    </b-card-body>
                </b-card>
            </div>

            <div
                class="col-12 col-md-6 col-lg-3"
                v-if="$authUser.hasRoleOrAdmin('organizations') && hasOrganizationsIn">
                <b-card
                    class="module-card apprentice-simple-card-with-banner card-icon-styling"
                    no-body
                    @click="redirectOrganizations">
                    <b-button
                        class="btn-university remove-icon-margin fa-4x"
                        variant="primary-icon-only">
                    </b-button>
                    <b-card-body body-class="module-card-body body">
                        <b-card-title title-tag="h5">{{ $t('management.school_organizations') }}</b-card-title>
                        <div class="muted-text">
                            {{ $t('management.manage_external_organizations_here_that_may_offer_internships') }}
                        </div>
                    </b-card-body>
                </b-card>
            </div>

            <div
                class="col-12 col-md-6 col-lg-3"
                v-if="$authUser.isAdmin()">
                <b-card
                    class="school-attachments-card apprentice-simple-card-with-banner card-icon-styling"
                    no-body
                    @click="redirectProfileSettings">
                    <b-button
                        class="btn-user-circle remove-icon-margin fa-4x"
                        variant="primary-icon-only"></b-button>
                    <b-card-body body-class="school-attachments-card-body body">
                        <b-card-title title-tag="h5">{{$t('management.profile_settings')}}</b-card-title>
                        <div class="muted-text">{{$t('management.edit_profile_settings')}}</div>
                    </b-card-body>
                </b-card>
            </div>

            <div
                class="col-12 col-md-6 col-lg-3"
                v-if="$authUser.isAdmin()">
                <b-card
                    class="school-attachments-card apprentice-simple-card-with-banner card-icon-styling"
                    no-body
                    @click="redirectSchoolAttachments">
                    <b-button
                        class="btn-toggle-off remove-icon-margin fa-4x"
                        variant="primary-icon-only"></b-button>
                    <b-card-body body-class="school-attachments-card-body body">
                        <b-card-title title-tag="h5">{{ $t('management.links') }}</b-card-title>
                        <div class="muted-text">
                            {{ $t('management.edit_links_here_that_relate_to_the_school') }}
                        </div>
                    </b-card-body>
                </b-card>
            </div>

            <div
                class="col-12 col-md-6 col-lg-3"
                v-if="($authUser.isAdmin() || $authUser.isTeacher()) && hasAppIn">
                <b-card
                    class="socie-mobile-app-card apprentice-simple-card-with-banner card-icon-styling"
                    no-body
                    @click="redirectSocieApp">
                    <b-button
                        class="btn-mobile-alt remove-icon-margin fa-4x"
                        variant="primary-icon-only"></b-button>
                    <b-card-body body-class="ssocie-mobile-app-card-body body">
                        <b-card-title title-tag="h5">App</b-card-title>
                        <div class="muted-text">
                            {{ $t('management.edit_your_own_school_app_here') }}
                        </div>
                    </b-card-body>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-management-index-component',
    props: [
        'userPermissionsIn',
        'hasModulesIn',
        'hasInternshipsIn',
        'hasOrganizationsIn',
        'hasLearningPathIn',
        'hasSluDashboardIn',
        'hasAppIn',
        'hasProfileChoiceIn',
        'hasCustomFormsIn',
        'sluSchoolSettingsIn',
    ],
    methods: {
        redirectAccounts() {
            window.location.href = this.routes.schoolAccounts();
        },

        redirectSkills() {
            window.location.href = this.routes.skills();
        },

        redirectProfile() {
            window.location.href = this.routes.managementProfile();
        },

        redirectModule() {
            window.location.href = this.routes.managementModule();
        },

        redirectInternship() {
            window.location.href = this.routes.internship();
        },

        redirectLearningPath() {
            window.location.href = this.routes.managementLearningPath();
        },

        redirectSluDashboard() {
            window.location.href = this.routes.sluDashboard();
        },

        redirectProfileChoice() {
            window.location.href = this.routes.managementProfileChoice();
        },

        redirectCustomForms() {
            window.location.href = this.routes.managementCustomForm();
        },

        redirectStatistics() {
            window.location.href = this.routes.managementStatistics();
        },

        redirectLas() {
            window.location.href = this.routes.managementLas();
        },

        redirectDigistudies() {
            window.location.href = this.routes.managementDigistudies();
        },

        redirectSchoolData() {
            window.location.href = this.routes.managementSchoolData();
        },

        redirectSchoolAttachments() {
            window.location.href = this.routes.managementSchoolAttachments();
        },

        redirectProfileSettings() {
            window.location.href = this.routes.managementProfileSettings();
        },

        redirectSocieApp() {
            window.location.href = this.routes.socieApp();
        },

        redirectOrganizations() {
            window.location.href = this.routes.managementOrganizations();
        },
        redirectPeriods() {
            window.location.href = this.routes.managePeriods();
        },
    },
};
</script>

<style scoped lang="scss">
.management {
    .row {
        > div {
            margin-bottom: $grid-gutter-width;
        }
    }
}
</style>
